import { render, staticRenderFns } from "./TeamFansList.vue?vue&type=template&id=fd3b98fa&scoped=true&"
import script from "./TeamFansList.vue?vue&type=script&lang=js&"
export * from "./TeamFansList.vue?vue&type=script&lang=js&"
import style0 from "./TeamFansList.vue?vue&type=style&index=0&id=fd3b98fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3b98fa",
  null
  
)

export default component.exports